import useEnquiryForm from "../hooks/useEnquiryForm";
import { EnquiryForm, EnquirySuccess } from "../components/enquiry/EnquiryForm";
import ContactBlock from "../components/enquiry/ContactBlock";
import { contact } from "../data";

export default function Enquiry() {
  const { form, status, onChange, onSubmit, reset } = useEnquiryForm();

  return (
    <main data-testid="enquiry-page" className="pb-12">
      <section className="border-b border-ink-700 section-padding pt-24 pb-16">
        <p className="font-mono text-[11px] tracking-[0.24em] uppercase text-textmuted mb-4">
          / contact / request
        </p>
        <h1 className="h-display text-5xl md:text-7xl max-w-[16ch]">
          Send an <span className="text-signal-amber">enquiry.</span>
        </h1>
        <p className="mt-6 font-mono text-sm text-textmuted max-w-2xl leading-relaxed">
          Tell us what you're sourcing — quantity, application, deadline. Our team in
          Patna responds within one business day.
        </p>
      </section>

      <section className="section-padding py-20 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7">
          {status.state === "success" ? (
            <EnquirySuccess onReset={reset} />
          ) : (
            <EnquiryForm form={form} status={status} onChange={onChange} onSubmit={onSubmit} />
          )}
        </div>

        <aside className="lg:col-span-5 space-y-6">
          <ContactBlock office={contact.head_office} />
          <ContactBlock office={contact.branch_office} />
        </aside>
      </section>
    </main>
  );
}
